/**
 * Sistema de Tipografía - Soccer Analytics App
 * Escalas tipográficas basadas en Material-UI
 */

const typography = {
  // Familia de fuentes
  fontFamily: {
    primary: "'Roboto', 'Arial', sans-serif",
    secondary: "'Inter', 'Helvetica', sans-serif",
    mono: "'Roboto Mono', 'Courier New', monospace",
  },

  // Pesos de fuente
  fontWeight: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
  },

  // Tamaños de fuente - Mobile First
  fontSize: {
    xs: '0.75rem',    // 12px
    sm: '0.875rem',   // 14px
    base: '1rem',     // 16px
    lg: '1.125rem',   // 18px
    xl: '1.25rem',    // 20px
    '2xl': '1.5rem',  // 24px
    '3xl': '1.875rem',// 30px
    '4xl': '2.25rem', // 36px
    '5xl': '3rem',    // 48px
  },

  // Line heights
  lineHeight: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.75,
    loose: 2,
  },

  // Estilos predefinidos para elementos
  styles: {
    // Headings
    h1: {
      fontSize: '2.25rem',      // 36px
      fontWeight: 700,
      lineHeight: 1.25,
      letterSpacing: '-0.02em',
    },
    h2: {
      fontSize: '1.875rem',     // 30px
      fontWeight: 700,
      lineHeight: 1.3,
      letterSpacing: '-0.01em',
    },
    h3: {
      fontSize: '1.5rem',       // 24px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h4: {
      fontSize: '1.25rem',      // 20px
      fontWeight: 600,
      lineHeight: 1.4,
    },
    h5: {
      fontSize: '1.125rem',     // 18px
      fontWeight: 600,
      lineHeight: 1.5,
    },
    h6: {
      fontSize: '1rem',         // 16px
      fontWeight: 600,
      lineHeight: 1.5,
    },

    // Body text
    body: {
      fontSize: '1rem',         // 16px
      fontWeight: 400,
      lineHeight: 1.5,
    },
    bodyLarge: {
      fontSize: '1.125rem',     // 18px
      fontWeight: 400,
      lineHeight: 1.6,
    },
    bodySmall: {
      fontSize: '0.875rem',     // 14px
      fontWeight: 400,
      lineHeight: 1.5,
    },

    // Caption / Helper text
    caption: {
      fontSize: '0.75rem',      // 12px
      fontWeight: 400,
      lineHeight: 1.4,
      letterSpacing: '0.03em',
    },

    // Overline (labels superiores)
    overline: {
      fontSize: '0.75rem',      // 12px
      fontWeight: 600,
      lineHeight: 1.5,
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
    },

    // Botones
    button: {
      fontSize: '0.875rem',     // 14px
      fontWeight: 600,
      lineHeight: 1.75,
      letterSpacing: '0.02em',
      textTransform: 'none',    // No uppercase por defecto
    },

    // Stats / Números grandes
    stat: {
      fontSize: '3rem',         // 48px
      fontWeight: 700,
      lineHeight: 1,
    },
  },

  // Responsive breakpoints para tipografía
  responsive: {
    // Mobile
    mobile: {
      h1: { fontSize: '1.875rem' },  // 30px
      h2: { fontSize: '1.5rem' },    // 24px
      h3: { fontSize: '1.25rem' },   // 20px
    },
    // Tablet
    tablet: {
      h1: { fontSize: '2.25rem' },   // 36px
      h2: { fontSize: '1.875rem' },  // 30px
      h3: { fontSize: '1.5rem' },    // 24px
    },
    // Desktop - usa los valores por defecto
  },
};

export default typography;
